import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./index.css";
import { connect } from "react-redux";
import Visible from "../../../../global/Visible";
const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});
class Footer extends Component {
  state = { tabWidth: window.innerWidth / 4, currentTab: 0 };
  render() {
    return (
      <div
        className="shadow-lg fixed-bottom pt-1"
        style={{
          // position: "absolute",
          // bottom: 0,
          backgroundColor: "#ffffff",
          zIndex: 10,
          borderTopLeftRadius: "20px",
          borderTopRightRadius: "20px",
        }}
      >
        <div className="d-flex align-items-center">
          <Link
            to={this.props.user.role.id === 9 ? `/home` : "/teacherhome"}
            className={
              this.state.currentTab === 0
                ? "text-center py-1 th-link-active"
                : "text-center py-1 th-link-inactive"
            }
            style={{ width: this.state.tabWidth }}
            onClick={() => this.setState({ currentTab: 0 })}
          >
            <i
              className={
                this.state.currentTab === 0
                  ? "fa fa-home th-24"
                  : "fa fa-home th-18"
              }
              aria-hidden="true"
            ></i>
            <div className="th-10">Home</div>
          </Link>
          <Visible roles={["IS_TEACHER", "IS_STUDENT"]}>
            <Link
              to={this.props.user.role.id === 9 ? `/courses` : "/tcourses"}
              className={
                this.state.currentTab === 1
                  ? "text-center py-1 th-link-active"
                  : "text-center py-1 th-link-inactive"
              }
              style={{ width: this.state.tabWidth }}
              onClick={() => this.setState({ currentTab: 1 })}
            >
              <i
                className={
                  this.state.currentTab === 1
                    ? "fa fa-book th-24"
                    : "fa fa-book th-18"
                }
                aria-hidden="true"
              ></i>
              <div className="th-10">Courses</div>
            </Link>
          </Visible>
          <Visible roles={["IS_TEACHER", "IS_STUDENT"]}>
            <Link
              to={
                this.props.user.role.id === 9
                  ? `/timetable`
                  : "/teachertimetable"
              }
              className={
                this.state.currentTab === 2
                  ? "text-center py-1 th-link-active"
                  : "text-center py-1 th-link-inactive"
              }
              style={{ width: this.state.tabWidth }}
              onClick={() => this.setState({ currentTab: 2 })}
            >
              <i
                className={
                  this.state.currentTab === 2
                    ? "fa fa-clock-o th-24"
                    : "fa fa-clock-o th-18"
                }
                aria-hidden="true"
              ></i>
              <div className="th-10">Time Table</div>
            </Link>
          </Visible>
          <Visible roles={["IS_ADMIN", "IS_SUPERADMIN", "IS_PRINCIPAL"]}>
            <Link
              to={"/birthday"}
              className={
                this.state.currentTab === 1
                  ? "text-center py-1 th-link-active"
                  : "text-center py-1 th-link-inactive"
              }
              style={{ width: this.state.tabWidth }}
              onClick={() => this.setState({ currentTab: 1 })}
            >
              <i
                className={
                  this.state.currentTab === 1
                    ? "fa fa-birthday-cake th-24"
                    : "fa fa-birthday-cake th-18"
                }
                aria-hidden="true"
              ></i>
              <div className="th-10">Birthday</div>
            </Link>
          </Visible>
          <Visible roles={["IS_PRINCIPAL"]}>
            <Link
              to={"/onlineclass"}
              className={
                this.state.currentTab === 2
                  ? "text-center py-1 th-link-active"
                  : "text-center py-1 th-link-inactive"
              }
              style={{ width: this.state.tabWidth }}
              onClick={() => this.setState({ currentTab: 2 })}
            >
              <i
                className={
                  this.state.currentTab === 2
                    ? "fa fa-desktop th-24"
                    : "fa fa-desktop th-18"
                }
                aria-hidden="true"
              ></i>
              <div className="th-10">Online Class</div>
            </Link>
          </Visible>
          <Visible roles={["IS_ADMIN", "IS_SUPERADMIN"]}>
            <Link
              to={"/dashboard"}
              className={
                this.state.currentTab === 2
                  ? "text-center py-1 th-link-active"
                  : "text-center py-1 th-link-inactive"
              }
              style={{ width: this.state.tabWidth }}
              onClick={() => this.setState({ currentTab: 2 })}
            >
              <i
                className={
                  this.state.currentTab === 2
                    ? "fa fa-credit-card th-24"
                    : "fa fa-credit-card th-18"
                }
                aria-hidden="true"
              ></i>
              <div className="th-10">Accounts</div>
            </Link>
          </Visible>
          <Link
            to="/profile"
            className={
              this.state.currentTab === 3
                ? "text-center py-1 th-link-active"
                : "text-center py-1 th-link-inactive"
            }
            style={{ width: this.state.tabWidth }}
            onClick={() => this.setState({ currentTab: 3 })}
          >
            <i
              className={
                this.state.currentTab === 3
                  ? "fa fa-user th-24"
                  : "fa fa-user th-18"
              }
              aria-hidden="true"
            ></i>
            <div className="th-10">Profile</div>
          </Link>
        </div>
      </div>
    );
  }
}
export default connect(mapStateToProps)(Footer);
